import React from "react";

interface SimpleModulePageProps {
  title: string;
  subtitle: string;
  icon: string;
  onBack?: () => void;
  children?: React.ReactNode;
}

// ===== 간단 페이지 헤더 =====
const PageHeader: React.FC<{ title: string; subtitle?: string; onBack?: () => void; right?: React.ReactNode }> = ({
  title,
  subtitle,
  onBack,
  right,
}) => (
  <header className="sticky top-0 z-30 flex items-center justify-between px-5 py-3 bg-white shadow-sm">
    <div className="flex items-center gap-2">
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          className="w-9 h-9 rounded-xl bg-slate-100 text-slate-700 flex items-center justify-center"
          title="뒤로"
        >
          ←
        </button>
      ) : (
        <div className="w-9" />
      )}
      <div className="flex flex-col">
        <span className="text-[15px] font-extrabold text-slate-900">{title}</span>
        {subtitle ? <span className="text-[10px] text-slate-400">{subtitle}</span> : null}
      </div>
    </div>
    <div className="flex items-center gap-2">{right}</div>
  </header>
);

// ===== 서브 페이지(복약/식단/측정/걷기/설정) =====
export const SimpleModulePage: React.FC<SimpleModulePageProps> = ({ title, subtitle, icon, onBack, children }) => {
  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-slate-100 pb-28 relative font-[system-ui]">
      <PageHeader
        title={title}
        subtitle={subtitle}
        onBack={onBack}
        right={<span className="w-9 h-9 rounded-xl bg-violet-50 text-violet-700 flex items-center justify-center">{icon}</span>}
      />
      <div className="px-4 pt-3">
        {children}
      </div>
    </div>
  );
};
